import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import AuditsUi from "./AuditsUi";
import {
  useCancelAuditsMutation,
  useGetAuditsQuery,
} from "../../store/Api/audits";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDeleteAdminMutation } from "../../store/Api/admins";
import { apiEncrypted, hidetoast, useDecodeToken } from "../../Utils/function";
import {
  useGetCentresQuery,
  useGetCityQuery,
  useGetRrbQuery,
  useGetStatesQuery,
} from "../../store/Api/common";
import { useGetUsersQuery } from "../../store/Api/users";
import ApiRoutes from "../../Utils/ApiRoutes";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { encrypt } from "../../Utils/crypto";
import  {rowsPerPage} from '../../Utils/constant'

function Audits() {
  const token = useSelector((state) => state.usertoken.token);
  const selectedCEN = useSelector((state) => state.cen.selectedCEN);
  const location = useLocation();
  const statusData = location?.state?.status
  const audit_statusData = location?.state?.audit_status
  const navigate = useNavigate();
  const decodedToken = useDecodeToken();
  const [cancelAudits] = useCancelAuditsMutation();
  const [deleteId, setDeleteId] = useState("");
  const [tableQaury, setTableQaury] = useState({
    search: "",
    rowsPerPage: rowsPerPage,
    currentPage: 1,
    rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
    stateId: "",
    cityId: "",
    centreId: "",
    auditorId: "",
    startDate: moment()
      .subtract(1, "month")
      .startOf("day")
      .format("DD-MM-YYYY"), // Default: Last month's current date
    endDate: moment().endOf("day").format("DD-MM-YYYY"), // Default: Today's date
    status: statusData ? statusData : '',
    cenId:selectedCEN?.cenId,
    audit_status:audit_statusData ? audit_statusData : '',
  });
  const [filtersId, setFiltersId] = useState({
    rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
    stateId: "",
    cityId: "",
    centreId: "",
    auditorId: "",
    startDate: moment()
      .subtract(1, "month")
      .startOf("day")
      .format("DD-MM-YYYY"), // Default: Last month's current date
    endDate: moment().endOf("day").format("DD-MM-YYYY"), // Default: Today's date
    status: statusData ? statusData : '',
    audit_status: audit_statusData ? audit_statusData : '',
  });
  const [selectData, setSelectData] = useState({
    rrb: [],
    city: [],
    states: [],
    centre: [],
    userData: [],
  });
  const shouldQuery = !!tableQaury?.cenId;


  const { data, isFetching, isLoading, refetch } = useGetAuditsQuery({
    search: tableQaury.search,
    limit: tableQaury.rowsPerPage,
    page: tableQaury.currentPage,
    rrb_id: tableQaury.rrbId,
    state_id: tableQaury.stateId,
    city_id: tableQaury.cityId,
    user_id: tableQaury.auditorId,
    status: !tableQaury.status
      ? ""
      : tableQaury.status === "submitted" 
      ? "completed" : tableQaury.status === 'pending' ? "pending"
      : "inprogress",
      
      cen_id:tableQaury?.cenId ? tableQaury?.cenId : selectedCEN?.cenId,
    start_date: tableQaury?.startDate,
    end_date: tableQaury?.endDate,
    audit_status: tableQaury?.audit_status || "",

    // centre_id: tableQaury.centreId,
  },
  
);
  const { data: userData } = useGetUsersQuery({
    search: "",
    limit: "",
    page: "",
  });
  const { data: rrb } = useGetRrbQuery({});
  const { data: states, refetch: refetchStates } = useGetStatesQuery(
    { rrbId: filtersId?.rrbId },
    {
      skip: !filtersId?.rrbId,
    }
  );
  const { data: city, refetch: refetchcity } = useGetCityQuery(
    { rrbId: filtersId?.rrbId, stateId: filtersId?.stateId },
    {
      skip: !filtersId?.rrbId || !filtersId?.stateId,
    }
  );
  const { data: centre, refetch: refetchcentre } = useGetCentresQuery(
    { cityId: filtersId?.cityId },
    {
      skip: !filtersId?.cityId,
    }
  );
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);
  useEffect(() => {
    if (selectedCEN?.cenId) {
      setTableQaury({
        ...tableQaury,
      cenId:selectedCEN?.cenId
      })
    }
  }, [selectedCEN?.cenId]);
  // Auto-hide toast after 3 seconds
  useEffect(() => {
    if (toast.message) {
      hidetoast();
    }
  }, [toast.message, dispatch]);
useEffect(() => {
if(filtersId?.cen_id){
  setTableQaury({
    ...tableQaury,
  cenId:filtersId?.cen_id
  })
}
},[filtersId])

  useEffect(() => {
    setSelectData({
      rrb: rrb?.data?.data,
      states: states?.data?.data,
      city: city?.data?.data,
      centre: centre?.data?.data,
      userData: userData?.data?.users,
    });
  }, [rrb, city, states, centre, userData]);
  useEffect(() => {
    if (filtersId?.rrbId && filtersId?.stateId) {
      refetchcity();
    }
    if (filtersId?.rrbId && filtersId?.stateId && filtersId?.cityId) {
      refetchcentre();
    }
  }, [filtersId]);
  useEffect(() => {
    if (
      tableQaury?.rrbId ||
      tableQaury?.stateId ||
      tableQaury?.cityId ||
      tableQaury?.centreId ||
      tableQaury?.auditorId ||
      tableQaury?.status ||
      tableQaury?.cenId ||
      tableQaury?.startDate ||
      tableQaury?.endDate ||
      tableQaury?.audit_status // Include this explicitly
    ) {
      refetch();
    }
  }, [tableQaury]);

  const onView = (row) => {
    navigate(`/audits/view-audit`, { state: { data: row } });
  };
  const onHistory = (row) => {
    navigate(`/history`,{state: {data: row}})
  }
  const deleteAuditFn = async () => {
    try {
      const response = await cancelAudits({ id: deleteId });
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };
  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
    setTableQaury({ ...tableQaury, currentPage: newPage });
  };
  const onPartial = (row) =>{
    navigate("/")
  }
  const columns = [
    ...((decodedToken?.role === 3 || decodedToken?.role === 4)
      ? [{ title: "RRB", dataKey: "rrb", isObject: true, objectKey: "name" }]
      : []),
    // { title: "Date", dataKey: "audit_date" },
    {
      title: "Date",
      dataKey: "audit_date",
      render: (audit_date) => {
        if (!audit_date) return "N/A";
        const date = new Date(audit_date);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    ...((decodedToken?.role != 5)
      ? [{
        title: "Auditor", // Single column for full name
        render: (_, row) =>
          `${row.user?.firstname || ""} ${row.user?.lastname || ""}`.trim() ||
          "N/A",
      },]
      : []),

    {
      title: "State",
      render: (_, row) => row?.centre?.city?.state?.name || "N/A",
    },
    {
      title: "City",
      render: (_, row) =>{return (         
         <p style={{width:"120px"}}>{row?.centre?.city?.name}</p>
              ) }  ,
    },
    {
      title: "Center",
      render: (_, row) => row?.centre?.name || "N/A",
    },
    {
      title: "Audit Trail",
      // dataKey: "status",
      render: (_, row) => {
        // console.log(row,"row");
        let status = row?.clone_id  ? "Copied" : "Latest";
        const getBadgeColor = (row) => {
          switch (status) {
            case "Latest":
              return "bg-inprogress_theme text-white"; // Yellow badge for in progress
            case "Copied":
              return "bg-rejected_theame text-white";
            default:
              return "bg-secondary text-white"; // Default gray badge for other statuses
          }
        };
        return (
          <div style={{width:"120px",display:"flex",flexDirection:"column",alignItems:"center"}}>
          <div className="d-flex justify-content-center">
          <span
            className={`badge ${getBadgeColor(status)}`}
            style={{ padding: "8px 5px" }}
          >
            {status.charAt(0).toUpperCase() + status.slice(1)}
          </span>
          </div>
          {status == "Copied" ?
          <p style={{fontSize:"12px",marginTop:"5px",textAlign:"center",width:"fit-content"}}>{row?.copied_from_cen_name}CEN 02/2025</p>
          :null}
          </div>
        );
      },
    },
    // { title: "Status", dataKey: "status" },
    ...((decodedToken?.role != 5)
    ? [ {
      title: "Center Status",
      // dataKey: "status",
      render: (_, row) => {
        let status = row?.status == "inprogress" ? "In Progress" : row?.status;
        const getBadgeColor = (row) => {
          switch (status) {
            case "completed":
              return "bg-completed_theame text-white"; // Green badge for completed
              case "approved":
                return "bg-approved_theame text-white";
            case "In Progress":
              return "bg-inprogress_theme text-white"; // Yellow badge for in progress
            case "rejected":
              return "bg-rejected_theame text-white";
            // case "":
            //   return ""
            default:
              return "bg-secondary text-white"; // Default gray badge for other statuses
          }
        };

        return (
          <div className="d-flex justify-content-center">
          <span
            className={`badge ${getBadgeColor(status)}`}
            style={{ padding: "8px 5px" }}
          >
            {status.charAt(0).toUpperCase() + status.slice(1)}
          </span>
          </div>
        );
      },
    },]
    : []),
    ...((decodedToken?.role != 5)
    ? [ {
      title: "Audit Status",
      // dataKey: "status",
      render: (_, row) => {
        let status = row?.approve_status == "partially_approved" ? "Conditional Approved" : row?.approve_status
        const getBadgeColor = (row) => {
          switch (status) {
            case "completed":
              return "bg-completed_theame text-white"; // Green badge for completed
              case "approved":
                return "bg-approved_theame text-white";
            case "inprogress":
              return "bg-inprogress_theme text-white"; // Yellow badge for in progress
            case "rejected":
              return "bg-rejected_theame text-white";
            case "Conditional Approved":
              return "bg-conditional_theame text-white"
            default:
              return "bg-secondary text-white"; // Default gray badge for other statuses
          }
        };

        return (
          <div className="d-flex justify-content-center">
          <span
            className={`badge ${getBadgeColor(status)}`}
            style={{ padding: "8px 5px" }}
          >
            {status?.charAt(0).toUpperCase() + status?.slice(1)}
          </span>
          </div>
        );
      },
    },]
    : []),
    // {
    //   title: "Auditor Status",
    //   // dataKey: "status",
    //   render: (_, row) => {
    //     let status =(row?.approve_status !== "pending" && row?.approve_status !== "partially_approved") ? row?.approve_status : row?.status;
    //     const getBadgeColor = (row) => {
    //       switch (status) {
    //         case "completed":
    //           return "bg-success text-white"; // Green badge for completed
    //           case "approved":
    //             return "bg-success text-white";
    //         case "inprogress":
    //           return "bg_blue_theame text-white"; // Yellow badge for in progress
    //         case "rejected":
    //           return "bg-danger text-white";
    //         default:
    //           return "bg-secondary text-white"; // Default gray badge for other statuses
    //       }
    //     };

    //     return (
    //       <span
    //         className={`badge ${getBadgeColor(status)}`}
    //         style={{ padding: "8px 5px" }}
    //       >
    //         {status.charAt(0).toUpperCase() + status.slice(1)}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   title: "ECA Status",
    //   // dataKey: "status",
    //   render: (_, row) => {
    //     let status =(row?.approve_status !== "pending" && row?.approve_status !== "partially_approved") ? row?.approve_status : row?.status;
    //     const getBadgeColor = (row) => {
    //       switch (status) {
    //         case "completed":
    //           return "bg-success text-white"; // Green badge for completed
    //           case "approved":
    //             return "bg-success text-white";
    //         case "inprogress":
    //           return "bg_blue_theame text-white"; // Yellow badge for in progress
    //         case "rejected":
    //           return "bg-danger text-white";
    //         default:
    //           return "bg-secondary text-white"; // Default gray badge for other statuses
    //       }
    //     };

    //     return (
    //       <span
    //         className={`badge ${getBadgeColor(status)}`}
    //         style={{ padding: "8px 5px" }}
    //       >
    //         {status.charAt(0).toUpperCase() + status.slice(1)}
    //       </span>
    //     );
    //   },
    // },
    {
      title: "Actions",
      render: (_, row) =>
        row?.status == "pending" ? (
          "-"
        ) : (
          <div className="d-flex justify-content-end">
                 {row?.status !== "inprogress"  ? (
            <button
              className="border-0 bg-transparent"
              onClick={() => onView(row)}
            >
              <i class="fas fa-eye  color_blue_theame"></i>
            </button>
                 ):
        
            null
                 }
                 {row.status === "completed" && Array.isArray(row.re_audit_requests) && row.re_audit_requests[0]?.status === "approved" && (
                  <button 
                  className="border-0 bg-transparent"
                  onClick={() => onHistory(row)}
                  >
                    <i class="fas fa-history color_blue_theame"></i>
                  </button>
                 )}
            <a
              target="_blank"
              href={`${process.env.REACT_APP_API_ROUTE}${encrypt(
                `${ApiRoutes.downloadPdf}/${row?.id}/${token}`
              )}`}
            >
              <button className="border-0 bg-transparent">
                <i class="fas fa-download"></i>
              </button>
            </a>
            <button
              className="border-0 bg-transparent"
              type="button"
              onClick={() => setDeleteId(row?.id)}
              data-toggle="modal"
              data-target="#modal-danger"
            >
              <i class="text-danger fas fa-window-close"></i>
            </button>
          </div>
        ),
    },
  ];
  const applyFilter = () => {
    setTableQaury({
      ...tableQaury,
      rrbId: filtersId?.rrbId,
      stateId: filtersId?.stateId,
      cityId: filtersId?.cityId,
      centreId: filtersId?.centreId,
      auditorId: filtersId?.auditorId,
      status: filtersId?.status,
      startDate: filtersId?.startDate,
      endDate: filtersId?.endDate,
      audit_status: filtersId?.audit_status
    });
  };

  const removeFilter = () => {
    setTableQaury({
      ...tableQaury,
      rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
      stateId: "",
      cityId: "",
      centreId: "",
      auditorId: "",
      startDate: moment()
        .subtract(1, "month")
        .startOf("day")
        .format("DD-MM-YYYY"), // Default: Last month's current date
      endDate: moment().endOf("day").format("DD-MM-YYYY"), // Default: Today's date
      status: "",
      audit_status:""
    });
    setFiltersId({
      rrbId: decodedToken?.role == 1 ? `${decodedToken?.rrb_id}` : "",
      stateId: "",
      cityId: "",
      centreId: "",
      auditorId: "",
      startDate: moment()
        .subtract(1, "month")
        .startOf("day")
        .format("DD-MM-YYYY"), // Default: Last month's current date
      endDate: moment().endOf("day").format("DD-MM-YYYY"), // Default: Today's date
      status: "",
      audit_status:""
    });
    setSelectData({
      rrb: rrb?.data?.data,
      userData: userData?.data?.users,
      states: decodedToken?.role == 1 ? states?.data?.data : [],
      city: [],
      centre: [],
    });
  };
// console.log(data,'data')
  return (
    <Layout>
      <AuditsUi
        data={data?.data?.data || []}
        loading={isLoading}
        columns={columns}
        tableQaury={tableQaury}
        onPageChange={handlePageChange}
        totalRecords={data?.data?.totalItems} // Assuming the API returns a total count
        deleteAuditFn={deleteAuditFn}
        setTableQaury={setTableQaury}
        selectData={selectData}
        setFiltersId={setFiltersId}
        refetchStates={refetchStates}
        refetchcity={refetchcity}
        setSelectData={setSelectData}
        filtersId={filtersId}
        applyFilter={applyFilter}
        removeFilter={removeFilter}
        decodedToken={decodedToken}
        toast={toast}
      />
    </Layout>
  );
}

export default Audits;
